<template>
  <a-modal
    width="1340px"
    :visible="active"
    :bodyStyle="modalBodyStyle"
    :footer="null"
    :closable="false"
    transitionName="none"
    maskTransitionName="none"
    @cancel="close"
  >
    <div class="category-selector">
        <page-block
          entityType="FNSClassesConfiguration"
          blockTitle="Изменить категорию"
          :showSidebarButton="false"
          :appConfig="appConfig"
          :blockConfig="activeSidebarItem.pageblocks[0]"
          categorySelectorPage
          @entityClick="editEntity"
        />
    </div>
  </a-modal>
</template>

<script>
import store from '@/store';
import {apolloClient} from "@/apolloClient";
import TABLE_QUERY from "@/queries/table";
import PageBlock from '@/pages/table/pageblock/PageBlock.vue';
import GET_QUERY from '@/queries/get';

export default {
  name: 'CategorySelector',
  components: { PageBlock },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: null,
    },
    appConfig: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      search: '',
      list: [],
      modalBodyStyle: {
        height: '70vh',
        // maxWidth: '1340px',
        width: '100%',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        minWidth: '30rem',
        padding: '30px',
      },
    };
  },
  computed: {
    filteredList() {
      return this.list.filter((item) => item.search.includes(this.search));
    },
    activeSidebarItem() {
      return store.state.activeSidebarItem
    }
  },

  methods: {
    close() {
      this.$emit('close');
    },
    editEntity(type, id) {
      this.$apollo.query({
        ...GET_QUERY,
        variables: {id, type},
        loadingKey: 'subConfigsLoading',
      })
        .then(({data}) => {
          this.$emit('select', data.get.document.data.name);
        })
        .catch(() => {
          this.$notification.error({
            message: `Не удалось получить данные исходного элемента \n${type}:${id}`,
          });
        });
    }
  },
};
</script>

<style lang="scss">
.category-selector {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__search {
    width: 388px;
    border-color: #e4eaf4;

    .ant-icon {
      font-size: 19px;
    }
  }

  &__list {
    @include scrollbars();
    overflow-y: scroll;
    flex: 1 1 100%;
    margin-top: 20px;
  }

  &__list-columns {
    columns: 3;
    column-gap: 55px;
  }

  &__item {
    margin-bottom: 5px;
    font-size: 1.5rem;
    display: inline-block;
    padding: 0 10px;
    width: 100%;
    cursor: pointer;
    line-height: 38px;
    border-radius: 6px;

    &:hover {
      background-color: #366dbb;
      color: #fff;
    }
  }
}
</style>
